import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import DashboardRightSection from "../../Components/DashboardRightSection/DashboardRightSection";
import ShortsVideo from "../../Components/ShortsVideo/ShortsVideo";
import ScrollNav from "../../Components/ScrollNav/ScrollNav";
import Chatbot from "../../Components/Chatbot/Chatbot";


function ShortsVideoPage() {
    return (
        <div className="BallotsPage" style={{ overflow: 'hidden' }}>
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <ShortsVideo />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
                <Chatbot />
                <ScrollNav />
            </div>
        </div>
    );
}

export default ShortsVideoPage;